export const TimeFormat = [
    {
        "formatName": "HH:mm:ss (24-Hour Format)",
        "format": "HH:mm:ss",
        "description": "24-hour time format without AM/PM"
    },
    {
        "formatName": "hh:mm:ss (12-Hour Format)",
        "format": "hh:mm:ss A",
        "description": "12-hour time format with AM/PM notation"
    }
]
